export default function WhySection() {
  const cards = [
    {
      icon: "ri-search-eye-line",
      title: "Product Discovery",
      desc: "Find organized product information faster with our comprehensive spreadsheet database covering thousands of items across multiple categories.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Quality Research",
      desc: "Understand QC photos, seller ratings, and detailed product specifications before making any purchase decision.",
    },
    {
      icon: "ri-scales-3-line",
      title: "Smart Comparison",
      desc: "Compare platforms, prices, and shopping methods side by side to make informed decisions on every purchase.",
    },
    {
      icon: "ri-book-open-line",
      title: "Beginner Guides",
      desc: "Learn step-by-step shopping strategies, from finding products to completing international orders safely.",
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Why Hipobuy Spreadsheet?
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Everything you need before your next purchase, organized and simplified
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {cards.map((card) => (
            <div
              key={card.title}
              className="group p-6 md:p-7 bg-background-50 rounded-lg border border-background-200/60 hover:border-accent-300 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100/80 text-accent-600 mb-4 group-hover:bg-accent-200 transition-colors duration-200">
                <i className={`${card.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                {card.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {card.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}